import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Download, FileDown } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { RESUMES } from '../mock/data';

const ResumeModal = ({ open, onClose }) => {
  const { t } = useLanguage();

  const handleDownload = (r) => {
    const a = document.createElement('a');
    a.href = r.url;
    a.download = r.filename;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => onClose?.(), 300);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="backdrop"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, y: 20, scale: 0.96 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.96 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="relative w-full max-w-lg bg-[#0f1422] border border-[rgba(196,163,90,0.3)] p-8 paper-texture"
          >
            <span className="absolute top-0 left-0 w-6 h-6 border-t border-l border-[#C4A35A]" />
            <span className="absolute top-0 right-0 w-6 h-6 border-t border-r border-[#C4A35A]" />
            <span className="absolute bottom-0 left-0 w-6 h-6 border-b border-l border-[#C4A35A]" />
            <span className="absolute bottom-0 right-0 w-6 h-6 border-b border-r border-[#C4A35A]" />

            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-[#8a7a54] hover:text-[#C4A35A] transition-colors"
              aria-label="Close"
            >
              <X size={20} />
            </button>

            <div className="label-small mb-3">{t.hero.cards.resume}</div>
            <h3 className="font-heading text-2xl text-[#F0EDE8] mb-2">{t.resumeChoose}</h3>
            <div className="gold-rule mb-6" />

            <div className="space-y-3">
              {RESUMES.map((r) => (
                <button
                  key={r.id}
                  onClick={() => handleDownload(r)}
                  className="group w-full flex items-center justify-between border border-[rgba(196,163,90,0.25)] bg-[rgba(196,163,90,0.03)] p-5 hover:bg-[rgba(196,163,90,0.08)] hover:border-[#C4A35A] transition-all duration-300 text-left"
                >
                  <div className="flex items-center gap-4">
                    <FileDown size={22} className="text-[#C4A35A]" />
                    <div>
                      <div className="font-heading text-lg text-[#F0EDE8] group-hover:text-[#C4A35A] transition-colors">
                        {r.label}
                      </div>
                      <div className="text-[10px] tracking-[0.3em] uppercase text-[#8a7a54] mt-1">
                        {r.filename}
                      </div>
                    </div>
                  </div>
                  <Download size={16} className="text-[#8a7a54] group-hover:text-[#C4A35A] group-hover:translate-y-0.5 transition-all" />
                </button>
              ))}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ResumeModal;
